import script from "./AdminOnboardingManageFormTextView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOnboardingManageFormTextView.vue?vue&type=script&setup=true&lang=js"

import "./AdminOnboardingManageFormTextView.vue?vue&type=style&index=0&id=fe1b180c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe1b180c"]])

export default __exports__